import React,{useState, Suspense} from "react";
import ReactDOM from 'react-dom';
import DataAdapter from "../../adapter/DataAdapter";

import { Card, CardBody, CardHeader, CardImg, CardLink, CardText, CardTitle, Col, Input, ListGroup, ListGroupItem, Row, Modal, ModalBody, ModalFooter, ModalHeader, Button, FormGroup, Label} from 'reactstrap';

class Scrap {
    constructor(){

    }

	selectByPerson = async (_person) =>{
        const _query    =   "SELECT rs.*, CONCAT(ifnull(p1.name,''),' ',ifnull(p1.lastname,'')) AS person, CONCAT(ifnull(p2.name,''),' ',ifnull(p2.lastname,'')) AS driver, ty.rb_type_desc AS type FROM rb_scrap rs LEFT JOIN rb_person p1 ON rs.person_id = p1.person_id LEFT JOIN rb_person p2 ON rs.driver_id = p2.person_id LEFT JOIN rb_types ty ON (ty.rb_type_no = rs.sp_type AND ty.rb_type='sp_type') WHERE rs.person_id = " +_person;
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }

	openFormScrap	= async	(props)	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormScrap = React.lazy(() => import('./PickupForm'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<FormScrap callback={(obj)=>resolve(obj)} projectId={props.prj_id} marketerId={props.marketer_id} personId={props.receiver_id} />
				</Suspense>
			, div);
		});
	
		return _return;
	}	


}
export default Scrap;